import { render, staticRenderFns } from "./BiReportList.vue?vue&type=template&id=046530c8&scoped=true"
import script from "./BiReportList.vue?vue&type=script&lang=js"
export * from "./BiReportList.vue?vue&type=script&lang=js"
import style0 from "./BiReportList.vue?vue&type=style&index=0&id=046530c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046530c8",
  null
  
)

export default component.exports